
import React, {Component} from 'react';
import {Button} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import IncentivePayeePageModal from './IncentivePayeePageModal'
class IncentivePayeeButton extends Component {

  constructor(...args){
    super(...args)
    this.state = {show:false}
  }

  onClick(){
    this.setState({show:true})
  }

  onSelectItem(item){
    this.setState({show:false})
    if(this.props.onSelectItem!==undefined){
      this.props.onSelectItem(item)
    }
  }

  render(){
    let {show} = this.state
    return (
      <div>        
        <Button onClick={this.onClick.bind(this)}><FontAwesome name='plus'/></Button>
        <IncentivePayeePageModal 
          show={show}
          onSelectItem={this.onSelectItem.bind(this)}
          onHide={()=>{this.setState({show:false})}}
        /> 
      </div>
    )
  }
}


export default IncentivePayeeButton;





// WEBPACK FOOTER //
// ./src/view/cashflow/IncentivePayeeButton.js